import CampaignEdit from './CampaignEdit.js';
import enhance from './enhancer';

export default enhance(CampaignEdit);
